import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import 'styled-components/macro';

import { useNotificationContext } from 'core/context/Notifications';
import { Notification } from 'play/atoms/notification/Notification';

interface NotificationsProps {
  bottomOffset?: boolean;
}

const Notifications = styled.div<NotificationsProps>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  position: fixed;
  left: 0;
  right: 0;
  bottom: ${props => (props.bottomOffset ? '90px' : '0px')};
  padding: 20px 20px 0;
  z-index: 9999;

  // We want to allow clicking through the flex container
  pointer-events: none;
`;

const NotificationsContainer = () => {
  const { path } = useRouteMatch();
  const { notifications, closeNotification } = useNotificationContext();

  const isNotesRoute = path === '/:teamSlug/tracks/:trackSlug/challenges/:challengeSlug/notes';

  return (
    <Notifications bottomOffset={isNotesRoute}>
      {notifications.map(({ id, type, title, duration, message }) => (
        <Notification
          key={id}
          id={id}
          type={type}
          title={title}
          duration={duration}
          message={message}
          onClose={() => closeNotification(id)}
        />
      ))}
    </Notifications>
  );
};

export default NotificationsContainer;
